export default "__VITE_ASSET__qvB_yB1d__"